import React from 'react';
import { Grid } from '@material-ui/core';

import { ContractForm } from 'views/Contract/components';
import { useStyles } from './styles';

export default () => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Grid container spacing={4}>
        <Grid item xs={12} style={{ padding: 12 }} >
          <ContractForm />
        </Grid>
      </Grid>
    </div>
  );
};
